var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-6"
  }, [_c('header', {
    staticClass: "theme--light v-navigation-drawer elevation-1",
    staticStyle: {
      "height": "50px",
      "border-radius": "5px",
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__content",
    staticStyle: {
      "height": "50px",
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "v-toolbar__title"
  }, [_c('h4', {
    staticClass: "black--text"
  }, [_c('span', {
    staticClass: "mango-red"
  }, [_vm._v("Comments on TRAID ")]), _vm._v("(" + _vm._s(_vm.comments.length) + ")")])])])]), _c('v-card', [_c('v-card-text', {
    staticClass: "elevation-1 pb-2"
  }, [_c('div', {
    staticClass: "d-flex mb-2",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.commentTypes,
      "item-text": "label",
      "item-value": "value",
      "label": "Comment type",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "disabled": _vm.creating
    },
    model: {
      value: _vm.newType,
      callback: function ($$v) {
        _vm.newType = $$v;
      },
      expression: "newType"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.toraBookings,
      "item-text": "text",
      "item-value": "value",
      "label": "Select booking",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "disabled": _vm.creating
    },
    model: {
      value: _vm.newBookingId,
      callback: function ($$v) {
        _vm.newBookingId = $$v;
      },
      expression: "newBookingId"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Add a comment on TRAID...",
      "hide-details": "",
      "solo": "",
      "clearable": "",
      "disabled": _vm.creating
    },
    model: {
      value: _vm.newComment,
      callback: function ($$v) {
        _vm.newComment = $$v;
      },
      expression: "newComment"
    }
  }), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "loading": _vm.creating,
      "depressed": "",
      "disabled": !_vm.newComment || !_vm.newBookingId
    },
    on: {
      "click": _vm.addComment
    }
  }, [_vm._v(" Add ")])], 1)]), _c('div', {
    staticStyle: {
      "max-height": "250px",
      "overflow-y": "auto",
      "background": "#f9f9f9"
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "text-center py-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "accent",
      "size": "32"
    }
  })], 1) : _vm.comments.length === 0 ? _c('div', {
    staticClass: "grey--text text--darken-1 py-4 text-center"
  }, [_vm._v("No comments")]) : _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.comments, function (c) {
    return _c('v-list-item', {
      key: c.commentId,
      staticClass: "px-3 py-2",
      staticStyle: {
        "border-bottom": "1px solid #efefef",
        "min-height": "unset"
      }
    }, [_c('v-list-item-content', {
      staticClass: "py-2"
    }, [_vm.editingId !== c.commentId ? _c('div', [_c('div', {
      staticClass: "caption grey--text mb-1"
    }, [_c('v-chip', {
      staticClass: "mr-2",
      staticStyle: {
        "font-size": "11px"
      },
      attrs: {
        "x-small": "",
        "label": "",
        "color": "grey darken-2",
        "dark": ""
      }
    }, [_vm._v(" " + _vm._s(_vm._f("formatType")(c.type)) + " ")]), _c('v-chip', {
      staticClass: "mr-2",
      staticStyle: {
        "font-size": "11px"
      },
      attrs: {
        "x-small": "",
        "label": "",
        "color": "grey lighten-2"
      }
    }, [_vm._v(" " + _vm._s(c.externalBookingCode) + " ")]), _vm._v(" " + _vm._s(c.lastUpdatedBy || c.createdBy) + " • " + _vm._s(_vm._f("getOnlyDate")(c.lastUpdatedOn || c.createdOn)) + " " + _vm._s(_vm._f("getOnlyTime")(c.lastUpdatedOn || c.createdOn)) + " "), _c('small', [_vm._v("(GMT+" + _vm._s(_vm.gmtDiff) + ")")])], 1), _c('div', {
      staticClass: "body-2"
    }, [_vm._v(_vm._s(c.comment))])]) : _c('div', {
      staticClass: "d-flex align-center",
      staticStyle: {
        "gap": "8px"
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": "",
        "autofocus": ""
      },
      model: {
        value: _vm.editText,
        callback: function ($$v) {
          _vm.editText = $$v;
        },
        expression: "editText"
      }
    }), _c('v-btn', {
      attrs: {
        "small": "",
        "text": ""
      },
      on: {
        "click": _vm.cancelEdit
      }
    }, [_vm._v("Cancel")]), _c('v-btn', {
      attrs: {
        "small": "",
        "color": "accent",
        "loading": _vm.saving
      },
      on: {
        "click": function ($event) {
          return _vm.saveEdit(c.commentId);
        }
      }
    }, [_vm._v("Save")])], 1)]), _vm.editingId !== c.commentId ? _c('v-list-item-action', {
      staticClass: "flex-row align-center ma-0",
      staticStyle: {
        "gap": "0"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.startEdit(c);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "20",
        "color": "third"
      }
    }, [_vm._v("mdi-pencil")])], 1), _c('v-btn', {
      attrs: {
        "icon": "",
        "loading": _vm.deleting === c.commentId
      },
      on: {
        "click": function ($event) {
          return _vm.removeComment(c);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "20",
        "color": "primary"
      }
    }, [_vm._v("mdi-delete")])], 1)], 1) : _vm._e()], 1);
  }), 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }